import debounce from 'lodash/debounce';
import { FormEvent, useCallback, useMemo, useState } from 'react';

import { inputClassName, searchbarClassName } from './styles';

export interface Props {
  search: string;
  setSearch: (v: string) => void;
}

const Searchbar = ({ search, setSearch }: Props) => {
  const [value, setValue] = useState<string>(search);

  const handleSearch = useMemo(
    () =>
      debounce((s: string) => {
        setSearch(s);
      }, 250),
    [setSearch],
  );

  const onChange = useCallback(
    (e: FormEvent<HTMLInputElement>) => {
      const { value: v } = e.target as HTMLInputElement;
      setValue(v);
      handleSearch(v);
    },
    [handleSearch],
  );

  return (
    <div className={searchbarClassName}>
      <input
        className={inputClassName}
        onChange={onChange}
        placeholder="Search for a GIF..."
        value={value}
      />
    </div>
  );
};

Searchbar.displayName = 'Searchbar';

export default Searchbar;
